export enum LayoutMode {
	Vertical,
	Horizontal
}
